import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import {getAll as getAuthors} from "app/requests/admin/authors";
import {getAll as getReviewers} from "app/requests/admin/reviewers";
import ContentEditor from "components/helpers/form/content-editor";
import Select from "components/helpers/form/select";
import Loading from "components/pages/loading";
import {useContent} from "lib/hooks";

const recordToOption = ({data, id, first_name: firstName, last_name: lastName}) => ({
  name: `${firstName} ${lastName}${data.title ? `, ${data.title}` : ""}`,
  value: id
});

function AdminCasesForm({onChange, onSubmit, value}) {
  const allCategories = useContent("Cases", "Categories").split(", ");
  const [authors, setAuthors] = useState(null);
  const categories = value("categories", []);
  const [reviewers, setReviewers] = useState(null);
  const onCategoryChange = (category, {target: {checked, name}}) => {
    const current = checked ? [...categories, category] : categories.filter((t) => t !== category);

    onChange({target: {name, value: current}});
  };

  useEffect(() => {
    getAuthors().then((data) => setAuthors(data.records));
    getReviewers().then((data) => setReviewers(data.records));
  }, []);

  if(!authors || !reviewers) { return <Loading />; }

  return (
    <form onSubmit={onSubmit}>
      {[
        {field: "author_ids", label: "Authors", records: authors},
        {field: "reviewer_ids", label: "Reviewers", records: reviewers}
      ].map(({field, label, records}) => (
        <div key={field} className="flex-nowrap input-group mb-3">
          <div className="input-group-prepend">
            <label className="input-group-text" htmlFor={`record-${field}`}>{label}</label>
          </div>
          <div className="d-block w-100">
            <Select
              className="form-control"
              multiple={true}
              id={`record-${field}`}
              name={field}
              onChange={onChange}
              options={records.map(recordToOption)}
              value={value(field)}
            />
          </div>
        </div>
      ))}
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <label className="input-group-text" htmlFor="record-title">Title</label>
        </div>
        <input
          className="form-control"
          id="record-title"
          name="title"
          onChange={onChange}
          placeholder="Title"
          required={true}
          type="text"
          value={value("title")}
        />
      </div>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <label className="input-group-text" htmlFor="record-categories">Categories</label>
        </div>
        <div className="form-control h-auto">
          {allCategories.map((category, index) => (
            <div key={category} className="custom-control custom-switch">
              <input
                checked={categories.includes(category)}
                className="custom-control-input"
                id={`record-categories-${index}`}
                name="categories"
                onChange={onCategoryChange.bind(null, category)}
                type="checkbox"
              />
              <label className="custom-control-label" htmlFor={`record-categories-${index}`}>{category}</label>
            </div>
          ))}
        </div>
      </div>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <label className="input-group-text" htmlFor="record-keywords">Keywords</label>
        </div>
        <input
          className="form-control"
          id="record-keywords"
          name="keywords"
          onChange={onChange}
          placeholder="Lungs, Spleen"
          type="text"
          value={value("keywords")}
        />
      </div>
      <div className="form-group">
        <ContentEditor
          id="record-content"
          label="Content"
          name="content"
          onChange={onChange}
          value={value("content")}
        />
      </div>
      <div className="custom-control custom-switch text-center mb-3">
        <input
          checked={value("disable_comments", false)}
          className="custom-control-input"
          id="record-disable-comments"
          name="disable_comments"
          onChange={onChange}
          type="checkbox"
        />
        <label className="custom-control-label" htmlFor="record-disable-comments">Disable Comments</label>
      </div>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <label className="input-group-text" htmlFor="record-email-subject">Email Subject</label>
        </div>
        <input
          className="form-control"
          id="record-email-subject"
          name="email_subject"
          onChange={onChange}
          placeholder="Email Subject"
          type="text"
          value={value("email_subject")}
        />
      </div>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <label className="input-group-text" htmlFor="record-email-preview-text">Email Preview Text</label>
        </div>
        <input
          className="form-control"
          id="record-email-preview-text"
          name="email_preview_text"
          onChange={onChange}
          placeholder="Email Preview Text"
          type="text"
          value={value("email_preview_text")}
        />
      </div>
      <div className="form-group text-center">
        <small className="form-text text-muted mb-3">This will not yet publish your case</small>
        <button type="submit" className="btn btn-primary">Submit</button>
      </div>
    </form>
  );
}

AdminCasesForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  value: PropTypes.func.isRequired
};

export default AdminCasesForm;
